const filters = (axios) => {
  return {

    /**
     * @param name
     * @method get
     * @api /api/filters/${name}
     */
    get(name) {
      return axios.get(`/filters/get/${name}`)
        .then((response) => response);
    },

    /**
     * @param url
     * @method get
     * @api /api/filters/{url}page={pagination.page}&ppage={pagination.perPage}
     */
    sendFilters(filters, pagination) {
      const addFilter = filters.url !== '' ? filters.url + '&' : filters.url;

      return axios.get(`/filters/${filters.name}${addFilter}page=${pagination.page}&ppage=${pagination.perPage}`)
        .then((response) => response);
    },

  };
};

export default filters;
